<aside class="main-sidebar">
  <div class="slimScrollDiv" style="
      overflow: scroll;
      height: 100%;
      position: absolute;
      width: inherit;
    ">
    <section class="sidebar" style="height: auto; overflow: hidden; width: auto;">
      <ul class="sidebar-menu">
        <li class="header">MENU</li>

        <li>
          <a routerLink="/home" routerLinkActive="hover-fixed"> <i class="fa fa-home"></i> <span>Home</span> </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CADASTRO')">
          <a routerLink="/cadastros" routerLinkActive="hover-fixed">
            <i class="fa fa-save"></i> <span>Cadastros</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_HABILITACAO')">
          <a routerLink="/habilitacao/listar" *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_TODOS')"
            routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
          <a class="cursor" (click)="gotoHabilitacao(1)"
            *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_PARCERIA')" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
          <a class="cursor" (click)="gotoHabilitacao(2)"
            *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_CONVENIO')" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
          <a class="cursor" (click)="gotoHabilitacao(3)"
            *ngIf="auth.temPermissao('ROLE_VISUALIZAR_HABILITACAO_INOVACAO')" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Habilitação</span>
          </a>
        </li>


        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_FINANCEIRO')">
          <a routerLink="/financeiro" routerLinkActive="hover-fixed">
            <i class="fa fa-dollar"></i> <span>Financeiro</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CONTABILIDADE')">
          <a routerLink="/contabilidade" routerLinkActive="hover-fixed">
            <i class="fa fa-calculator"></i> <span>Contabilidade</span>
          </a>
        </li>

        
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EDITAL_RECADASTRAMENTO')">
          <a routerLink="/editais-recadastramento" routerLinkActive="hover-fixed">
            <i class="fa  fa-id-card"></i>
            <span>Editais de Recadastramento</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EDITAL_CREDENCIAMENTO')">
          <a routerLink="/editais-credenciamento" routerLinkActive="hover-fixed">
            <i class="fa  fa-balance-scale"></i>
            <span>Editais de Credenciamento</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CHAMAMENTO_PUBLICO')">
          <a routerLink="/editais-chamamento/listar" routerLinkActive="hover-fixed">
            <i class="fa fa-legal"></i>
            <span>Editais de Cham. Público</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EMENDA_PARLAMENTAR')">
          <a routerLink="/emenda-parlamentar" routerLinkActive="hover-fixed">
            <i class="fa fa-suitcase"></i> <span>Emenda Parlamentar</span>
          </a>
        </li>


        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_MODELOS')">
          <a routerLink="/modelo" routerLinkActive="hover-fixed">
            <i class="fa fa-wrench"></i> <span>Modelos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_TRIBUTOS')">
          <a routerLink="/tributos" routerLinkActive="hover-fixed">
            <i class="fas fa-balance-scale"></i> <span>Tributos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_FROTA')">
          <a routerLink="/frota" routerLinkActive="hover-fixed">
            <i class="fas fa-car"></i> <span>Frota</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_CONTROLE_INTERNO')">
          <a routerLink="/controle-interno" routerLinkActive="hover-fixed">
            <i class="fa fa-search"></i> <span>Controle Interno</span>
          </a>
        </li>

        <!--
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PROPOSTA')">
          <a routerLink="/proposta" routerLinkActive="hover-fixed">
            <i class="far fa-folder"></i> <span>Proposta</span>
          </a>
        </li>
        -->

        <li *ngIf="auth.temPermissao('ROLE_MENU_PLANOS_SIG3')">
          <a routerLink="/planos/listar" routerLinkActive="hover-fixed">
            <i class="fa fa-angle-right"></i> <span>Planos de trabalho</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_PROJETOS')">
          <a routerLink="/projetos" routerLinkActive="hover-fixed">
            <i class="fa fa-file-text" aria-hidden="true"></i> <span>Projetos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PROJETOS_CONCLUIDOS')">
          <a routerLink="/projetos-concluidos" routerLinkActive="hover-fixed">
            <i class="fas fa-thumbs-up"></i> <span>Projetos Concluídos</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PENDENCIAS')">
          <a routerLink="/pendencia" routerLinkActive="hover-fixed">
            <i class="fa fa-tasks"></i> <span>Pendências</span>
          </a>
        </li>

        <li>
          <a routerLink="/patrocinio/propostas" *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_PATROCINIO')"
            routerLinkActive="hover-fixed">
            <i class="fa fa-money"></i>
            <span>Patrocínio</span>
          </a>
        </li>

        <li>
          <a routerLink="/pmis/cadastrar" *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_MANIFESTACAO_INT_SOCIAL')"
            routerLinkActive="hover-fixed">
            <i class="far fa-file-alt"></i>
            <span>Manifestação de Int. Social</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_ADMINISTRACAO')">
          <a routerLink="/relatorios" routerLinkActive="hover-fixed">
            <i class="fa fa-bar-chart"></i> <span>Relatórios</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_PERFIL_PERMISSAO')">
          <a class="cursor" routerLinkActive="hover-fixed" routerLink="/perfil-permissao">
            <i class="fa fa-cogs"></i> <span>Perfil / Permissão</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_ADMINISTRACAO')">
          <a routerLink="/administracao/listar" routerLinkActive="hover-fixed">
            <i class="fa fa-briefcase"></i> <span>Administração</span>
          </a>
        </li>

        <li>
          <a routerLink="/tutoriais" routerLinkActive="hover-fixed">
            <i class="fas fa-user-graduate"></i> <span>Tutoriais</span>
          </a>
        </li>

        <!-- Base de conhecimento (ADR-0019): ler e de todo mundo. Uma base que so o autor
             le nao diminui a curva de aprendizado de ninguem. -->
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_BASE_CONHECIMENTO')">
          <a routerLink="/base-conhecimento" routerLinkActive="hover-fixed">
            <i class="fa fa-book"></i> <span>Base de conhecimento</span>
          </a>
        </li>

        <!-- AUDESP (ADR-0020): trabalho da controladoria, nao de qualquer usuario. -->
        <li *ngIf="auth.temPermissao('ROLE_AUDESP')">
          <a routerLink="/audesp" routerLinkActive="hover-fixed">
            <i class="fa fa-balance-scale"></i> <span>AUDESP</span>
          </a>
        </li>

        <!-- Anexos da IN 01/2020 (ADR-0033). Mesma permissao do AUDESP: e o mesmo
             dever, do mesmo setor, para o mesmo Tribunal. -->
        <li *ngIf="auth.temPermissao('ROLE_AUDESP')">
          <a routerLink="/relatorios-tce" routerLinkActive="hover-fixed">
            <i class="fa fa-file-text"></i> <span>Relatórios TCE-SP</span>
          </a>
        </li>

        <!-- Os anexos que sao POR AJUSTE, e nao do exercicio inteiro: Termo de
             Ciencia, Demonstrativo Integral e LC-02 (ADR-0037 a ADR-0039). Entrada
             propria porque o filtro de um nao serve para o outro. -->
        <li *ngIf="auth.temPermissao('ROLE_AUDESP')">
          <a routerLink="/relatorios-tce/anexos-do-ajuste" routerLinkActive="hover-fixed">
            <i class="fa fa-files-o"></i> <span>Anexos por ajuste</span>
          </a>
        </li>

        <!-- O PC-01 e o unico dos dezenove anexos que tem CADASTRO: a Lei Orcamentaria
             e os decretos de credito adicional nao sao registro de parceria e nao
             existem no SIGRP (ADR-0043). Entrada propria porque a tela grava, e as
             outras duas so leem. -->
        <li *ngIf="auth.temPermissao('ROLE_AUDESP')">
          <a routerLink="/relatorios-tce/pc01" routerLinkActive="hover-fixed">
            <i class="fa fa-balance-scale"></i> <span>PC-01 — Execução Orçamentária</span>
          </a>
        </li>

        <!-- Notas fiscais repetidas (ADR-0041). Mesma permissao dos anexos: o relatorio
             aponta dinheiro possivelmente contado duas vezes, e nao pode ficar visivel
             a quem esta sendo conferido. -->
        <li *ngIf="auth.temPermissao('ROLE_NOTAS_FISCAIS_REPETIDAS')">
          <a routerLink="/notas-fiscais" routerLinkActive="hover-fixed">
            <i class="fa fa-clone"></i> <span>Notas fiscais repetidas</span>
          </a>
        </li>

        <!-- Remessa CNAB de pagamento em lote (ADR-0044). Permissao de ordem bancaria:
             o arquivo e uma ordem de pagamento, e nao uma consulta. -->
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_REMESSA_CNAB')">
          <a routerLink="/remessa-cnab" routerLinkActive="hover-fixed">
            <i class="fa fa-university"></i> <span>Remessa de pagamento (CNAB)</span>
          </a>
        </li>

        <!-- Fluxos de processo em BPMN 2.0 (ADR-0034). Sem *ngIf de permissao: o
             fluxo mapeado e para as pessoas seguirem, e esconde-lo de quem trabalha
             nele derrotaria o proposito. Desenhar e que exige permissao. -->
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_FLUXOS_PROCESSO')">
          <a routerLink="/fluxos-bpmn" routerLinkActive="hover-fixed">
            <i class="fa fa-sitemap"></i> <span>Fluxos de processo</span>
          </a>
        </li>

        <!-- Classificação da despesa (ADR-0025): custos diretos/indiretos e o
             previsto x realizado por natureza.

             Gate de LEITURA: ROLE_PROJETO_RELATORIOS. Ela existe (a que eu ia
             usar, ROLE_VISUALIZAR_RELATORIO_FINANCEIRO, não existe no banco e
             teria escondido a tela de todo mundo em silêncio). Medida depois:
             está em 50 dos 58 perfis, 3.783 usuários — larga, e por isso serve
             só para LER. Escrever exige ROLE_CLASSIFICAR_NATUREZA_CUSTO (V21),
             que está em 2 perfis. Um número errado aqui é pior que nenhum: uma
             versão anterior deste comentário dizia "8 perfis". -->
        <li *ngIf="auth.temPermissao('ROLE_CLASSIFICACAO_DESPESA')">
          <a routerLink="/classificacao-despesa" routerLinkActive="hover-fixed">
            <i class="fa fa-balance-scale"></i> <span>Classificação da despesa</span>
          </a>
        </li>

        <!-- Tipos de Programa (ADR-0023): quem configura o fluxo de aprovacao de
             todos os projetos nao e quem toca um projeto. -->
        <li *ngIf="auth.temPermissao('ROLE_GERENCIAR_TIPO_PROGRAMA')">
          <a routerLink="/tipos-de-programa" routerLinkActive="hover-fixed">
            <i class="fa fa-sitemap"></i> <span>Tipos de programa</span>
          </a>
        </li>

        <!-- Carga massiva (ADR-0022): importar 3.000 despesas e a operacao mais
             destrutiva que o sistema oferece, e por isso tem permissao propria. -->
        <li *ngIf="auth.temPermissao('ROLE_CARGA_MASSIVA')">
          <a routerLink="/carga-massiva" routerLinkActive="hover-fixed">
            <i class="fa fa-upload"></i> <span>Carga massiva</span>
          </a>
        </li>

        <!-- ========= Suporte (ADR-0017) ========= -->

        <!-- Sem permissao: abrir um chamado e direito de quem usa o sistema. -->
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_SUPORTE')">
          <a routerLink="/suporte/meus-chamados" routerLinkActive="hover-fixed">
            <i class="fa fa-life-ring"></i> <span>Suporte</span>
          </a>
        </li>

        <!-- A fila e da equipe de suporte, e quem decide de verdade e o servidor. -->
        <li *ngIf="auth.temPermissao('ROLE_ATENDER_CHAMADO')">
          <a routerLink="/suporte/atendimento" routerLinkActive="hover-fixed">
            <i class="fa fa-headphones"></i> <span>Atendimento</span>
          </a>
        </li>

        <!-- ========= Modulo escolar ========= -->

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_EDUCACAO')">
          <a routerLink="/educacao-escolar" routerLinkActive="hover-fixed">
            <i class="fas fa-graduation-cap"></i> <span>Educação</span>
          </a>
        </li>

        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_ADMINISTRACAO')">
          <a routerLink="/assinador-documentos" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Assinador Documentos</span>
          </a>
        </li>

        <!-- Assinatura digital nativa (ADR-0030, itens 6, 60 e 92).
             Fica AO LADO do assinador antigo, que embute um site de terceiro
             (assinador-sigrp.vercel.app) e continua no ar: trocar duas coisas de
             uma vez e como se perde o controle do que quebrou. Desligar o antigo
             e decisao de quem opera. -->
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_ASSINATURA_DIGITAL')">
          <a routerLink="/assinatura" routerLinkActive="hover-fixed">
            <i class="fa fa-pencil-square-o"></i> <span>Assinatura digital</span>
          </a>
        </li>



        <li>&nbsp;</li>
        <li>&nbsp;</li>
      </ul>
    </section>
  </div>
</aside>
